import {
  TACAccountVerifyResource,
  TACCoursesResource,
  TACActivitiesResource,
  TACAvailabilityResource,
  TACBookCourseResource,
  TACBookActivityResource,
} from "./resources";

export function getAllCourses({ from, to }) {
  return new Promise((resolve, reject) => {
    TACCoursesResource.get({ from, to }).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function getAllActivities({ from, to }) {
  return new Promise((resolve, reject) => {
    TACActivitiesResource.get({ from, to }).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function checkAvailability({ activityId, date, language }) {
  return new Promise((resolve, reject) => {
    TACAvailabilityResource.get({
      activityId,
      date,
      language,
    }).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function bookActivity({
  activityId,
  date,
  start,
  end,
  schedulingFor,
  notes,
  language,
}) {
  return new Promise((resolve, reject) => {
    TACBookActivityResource.save(
      {},
      { activityId, date, start, end, schedulingFor, notes, language }
    ).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function postAccountVerify(payload) {
  return new Promise((resolve, reject) => {
    TACAccountVerifyResource.save({}, payload).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function bookCourse({ courseId, language, numberOfPersons }) {
  return new Promise((resolve, reject) => {
    TACBookCourseResource.save(
      {},
      { bookingId: courseId, language, numberOfPersons }
    ).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
